export const AUTH_HEADERS = {
  BEARER: 'Bearer',
};
